/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import { connect } from 'react-redux';
import ETextSetup from './ETextSetup';
import {getFrontCoverPageDetails, getFrontCoverThumbnailURL} from "../../../_thunks/cover.thunk";
import {getEtextPublishStatuses, sendInviteEmail,getStudentInviteLink, getEtextOptimizeStatuses} from "../../../_thunks/collection.thunk";
import {setSubscriptionLength} from "../../../_actions/access.code.actions";
function mapStateToProps(state, props) {
    return {
        collectionId : state.activeCollection.collectionId,
        coverPageTextInfo: state.frontCover,
        orderDetails: state.orderDetails,
        etextStatuses: state.etextStatuses,
        bookdetails: state.bookdetailsreducer,
        subscriptionLength: state.accessCodeSetup.subscriptionLength
    };
}

const mapDispatchToProps = dispatch => {
    return {
        getFrontCoverPage : (collectionId) => {
            dispatch(getFrontCoverThumbnailURL(collectionId, "FrontCoverThumbnail"));
        },
        getEtextStatuses : (collectionId) => {
            dispatch(getEtextPublishStatuses(collectionId));
            dispatch(getEtextOptimizeStatuses(collectionId));
        },
        sendInviteEmail : (collectionId) => {
            dispatch(sendInviteEmail(collectionId));
        },
        setSubscriptionLength : (length) => {
            dispatch(setSubscriptionLength(length));
        },
        callStudentInviteLink: (collectionId) => {
            return getStudentInviteLink(collectionId);
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ETextSetup);



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/ETextSetupLink.js